import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import store from 'redux/store';
import { Provider } from 'react-redux';
import { migrateLegacyTokenCookies } from 'helpers/token';
import 'antd/dist/antd.min.css';
import 'assets/styles/main.scss';

// Phải chạy trước khi render: route guard đọc token ngay ở lần render đầu tiên.
migrateLegacyTokenCookies();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
